import React from "react";
import { FaFacebookSquare, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";

const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Plan Your Visit", href: "#visit" },
  { label: "Gallery", href: "#gallery" },
  { label: "Watch Live", href: "#watch" },
  { label: "Contact", href: "#contact" },
];

const Footer = () => {
  return (
    <footer className="bg-maroon-dark text-white">
      <div className="mx-auto grid max-w-[1240px] gap-10 px-4 py-16 md:grid-cols-3">
        {/* Brand */}
        <div>
          <h2 className="font-serif text-2xl font-bold">
            The Little Flock <span className="text-peach">Tabernacle</span>
          </h2>
          <p className="mt-4 max-w-sm text-white/70">
            An Apostolic, End-Time Message church serving Kitchener, Waterloo and
            Cambridge, Ontario. We stream most Sunday services on Facebook —
            worship with us wherever you are.
          </p>
          <a
            href="https://www.facebook.com/littleflockchurchkitchener"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="The Little Flock on Facebook"
            className="mt-5 inline-flex items-center gap-2 text-peach transition hover:text-white"
          >
            <FaFacebookSquare size={28} />
            <span>Follow us on Facebook</span>
          </a>
        </div>

        {/* Quick links */}
        <div>
          <h3 className="font-serif text-lg font-bold text-peach">Explore</h3>
          <ul className="mt-4 space-y-2">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  className="text-white/70 transition hover:text-white"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3 className="font-serif text-lg font-bold text-peach">Visit Us</h3>
          <ul className="mt-4 space-y-3 text-white/70">
            <li className="flex items-start gap-3">
              <FaMapMarkerAlt className="mt-1 shrink-0 text-terracotta" />
              <span>1485 Mary Avenue, Cambridge, ON N3H 4N8</span>
            </li>
            <li className="flex items-center gap-3">
              <FaPhoneAlt className="shrink-0 text-terracotta" />
              <a href="tel:+15195809576" className="hover:text-white">
                519-580-9576
              </a>
            </li>
            <li className="flex items-center gap-3">
              <FaEnvelope className="shrink-0 text-terracotta" />
              <a href="mailto:jose@thelittleflock.com" className="hover:text-white">
                jose@thelittleflock.com
              </a>
            </li>
          </ul>
          <p className="mt-4 text-sm text-white/60">
            Sunday Worship 1:30 PM · Friday Prayer 7:00 PM
          </p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <p className="mx-auto max-w-[1240px] px-4 py-6 text-center text-sm text-white/50">
          © {new Date().getFullYear()} The Little Flock Tabernacle. All rights
          reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
